import { __rest, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
import classNames from './../../external_lib/classnames/index.js';
import styles from '../../components/base/HorizonModal/index.module.scss.js';
import btnStyles from '../../components/base/HorizonButton/index.module.scss.js';
import AntModal from './../../external_lib/antd/es/modal/index.js';
function HorizonModal(_a) {
  var _b;
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return React__default.createElement(AntModal, __assign({}, restProps, {
    className: classNames(styles.horizonModal, className),
    okButtonProps: __assign({
      className: btnStyles.horizonButton
    }, (_b = restProps.okButtonProps) !== null && _b !== void 0 ? _b : {})
  }), children);
}
export { HorizonModal as default };
//# sourceMappingURL=index.js.map
